class Constants {
  static get els() {
    let constants = {
      addToSamplesBtn: '[data-add-to-samples]',
      sampleProductLimit: 3,
      timeFrame: '3-month period',
      requestSampleButtonText: 'Request Sample',
      requestSampleKitButtonText: 'Request Sample Kit',
      limitReachedButtonText: 'Sample Limit Reached',
      addedToSamplesButtonText: 'Added to Samples',
      sampleFormStepOnePath: '/pages/product-samples?step=1',
    };
    return constants;
  }
  static get events() {
    let constants = {
      SAMPLE_ADDED: 'SAMPLE_ADDED',
      SAMPLE_ADDED_PFv2: 'SAMPLE_ADDED_PFv2',
    };
    return constants;
  }
  static get locations() {
    let constants = {
      ProductCard: 'Product Card',
      ProductFinder: 'Product Finder',
      PDP: 'PDP',
      Collection: 'Collection',
    };
    return constants;
  }
}
export { Constants };
